import React from 'react';
import {
  Stack,
  Input,
  Button,
  CircularProgress,
  Autocomplete,
} from '@ltvco/refresh-lib/theme';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { theme } from 'theme';
import { ErrorMessageWithIcon } from 'components/shared/ErrorMessageWithIcon';
import { getAbbrStatesAsArray } from '@ltvco/refresh-lib/utils';

interface IRepairDataFormProps {
  vinOrVehicleInfo: string;
  location: string;
  repairDescription: string;
  shopQuote: string;
  error: string | null;
  isLoading: boolean;
  onVinOrVehicleInfoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLocationChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: string | null,
  ) => void;
  onRepairDescriptionChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onShopQuoteChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e?: React.FormEvent<HTMLFormElement>) => Promise<void>;
}

/**
 * RepairDataForm - Form for entering repair cost estimation information
 * @component
 */
export const RepairDataForm = ({
  vinOrVehicleInfo,
  location,
  repairDescription,
  shopQuote,
  error,
  isLoading,
  onVinOrVehicleInfoChange,
  onLocationChange,
  onRepairDescriptionChange,
  onShopQuoteChange,
  onSubmit,
}: IRepairDataFormProps) => {
  const states = getAbbrStatesAsArray().filter(
    (abbrState: string) => abbrState !== 'All',
  );

  return (
    <Stack direction="row" width="100%">
      <AutoAwesomeOutlined sx={{ color: theme.palette.primary.main }} />
      <form onSubmit={onSubmit} style={{ width: '100%', marginLeft: '10px' }}>
        <Stack spacing={3} width={{ xs: '100%', md: '360px' }}>
          <Stack spacing={1}>
            <Input
              fullWidth
              value={vinOrVehicleInfo}
              onChange={onVinOrVehicleInfoChange}
              placeholder="VIN, License Plate or Year Make Model"
              disabled={isLoading}
            />
            <Autocomplete
              options={states}
              value={location}
              onChange={onLocationChange}
              renderInput={(params) => (
                <Input {...params} placeholder="Location" />
              )}
              disabled={isLoading}
            />
            <Input
              fullWidth
              value={repairDescription}
              onChange={onRepairDescriptionChange}
              placeholder="Repair Description"
              disabled={isLoading}
            />
            <Input
              fullWidth
              value={shopQuote}
              onChange={onShopQuoteChange}
              placeholder="Shop Quote (optional)"
              disabled={isLoading}
            />
          </Stack>
          <ErrorMessageWithIcon errorMessage={error || ''} />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={
              !vinOrVehicleInfo || !location || !repairDescription || isLoading
            }
            startIcon={isLoading ? <CircularProgress size={20} /> : null}
          >
            Get Estimate
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};
